'use client';
import {Button} from "@/shadcn/components/ui/button";
import {ChevronUp} from "lucide-react";
import {useEffect, useState} from "react";

// Define possible top positions as an enum or object
type TopPosition = 'default' | 'medium' | 'high';

export const ScrollToTopButton = ({position = 'default'}: { position?: TopPosition }) => {
    const [showScrollToTop, setShowScrollToTop] = useState(false);
    const [lastScrollY, setLastScrollY] = useState(0);
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > 300 && currentScrollY < lastScrollY) {
                setShowScrollToTop(true);
            } else {
                setShowScrollToTop(false);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    const scrollToTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    };

    // Mobile: unten rechts, oberhalb des fixed "Alle Filter"-Streifens (h-16),
    // damit der Button NICHT den sticky "… bei möbelguru"-Cobrand-Header oben überdeckt.
    // Desktop (sm): unverändert unten rechts. position-Prop bleibt für Abwärtskompat.
    return <Button
        onClick={scrollToTop}
        size={'xs'}
        variant={'outline'}
        className={`z-50 transition-opacity duration-400 ease-in-out opacity-0 ${showScrollToTop && 'opacity-100 fixed'} bottom-24 right-4 sm:bottom-[15%] sm:right-4 text-xs shadow-lg hover:bg-amber-600 hover:text-white bg-amber-500 active:bg-amber-600 active:text-white text-white`}
        aria-label="Scroll to top"
    >
        Nach oben
        <ChevronUp className={'h-4 w-4'}/>
    </Button>
}
